<template>
     <div class="card border-0">
         <div class="card-header">
             <span>Login Information</span>
         </div>
         <div class="card-body gray-bg profile__login">
             <div class="row justify-content-center pl-4 pr-4">
                 <div class="col-md-12" id="user-form">
                     <p v-if="errors.length" class="has-error">
                         <b class="help-block">Please correct the following error(s):</b>
                     <ul>
                         <li v-for="error in errors" class="help-block">{{ error }}</li>
                     </ul>
                     </p>
                     <div class="form-group row">
                         <label for="email" class="col-sm-4 col-form-label">Email</label>
                         <div class="col-sm-8">
                             <input type="text" readonly class="form-control-plaintext" id="email" name="email" v-model="u.email">
                         </div>
                         <small class="col-sm-4 text-danger small-hint">(Update email below)</small>
                     </div>
                     <div class="d-flex justify-content-center">
                         <a :href="optumMangeProfileLink" class="btn btn-primary">Manage Password</a>
                     </div>
                 </div>
             </div>
         </div>
     </div>

</template>

<script>
    export default {
        props:['user', 'optumMangeProfileLink'],
        mounted() {

        },
        created: function() {

        },
        data(){
            return {
                errors: [],
                route: '/api/user',
                u:this.user
            }
        },
        methods:{

            updateUser(e){
                let validationResult = this.validateForm();
                if (validationResult === false) {
                    e.preventDefault();
                    return false;
                }

                axios.post(`/api/user/current-password/validate`, {
                  current_password: this.u.current_password
                }).then(response => {
                  if (! response.data.Status) {
                    this.$notify({
                      type: 'error',
                      title: 'Error',
                      text: response.data.Message
                    });

                    return;
                  }

                  this.$http.put(this.route, this.u)
                    .then(function(response) {
                        $('.has-error').removeClass('has-error')
                        $('.help-block').remove()
                        this.showModal=false;
                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: 'Login Information Updated!'
                        });
                    }, (response) => {
                        this._handleErrors(response.data, '#user-form')
                    })
                }).catch(error => console.log(error));
            },
            validateForm() {
                this.errors = [];

                if (this.u.username && this.u.password) {
                    return true;
                }

                if (!this.u.username) {
                    this.errors.push('Username required.');
                }

                if (!this.u.password) {
                    this.errors.push('Password required.');
                }
                if (!this.u.current_password) {
                    this.errors.push('Current Password required.');
                }

                if (this.u.password !== this.u.password_confirmation) {
                    this.errors.push('Password Confirmation does not match.');
                }

                return false;
            },
            _handleErrors: function(items, selector)
            {
                $('.has-error').removeClass('has-error')
                $('.help-block').remove()

                for (var error in items['errors']) {
                    if (items['errors'].hasOwnProperty(error)) {
                        var text = error;
                        var parts = text.split('.');
                        var name = parts.pop();
                        var el = $(selector + ' [name="'+name+'"]')
                        el.closest('.form-group').addClass('has-error')
                        $( '<p class="help-block">'+(items['errors'][error].join(', '))+'</p>' ).insertAfter(selector + ' [name="'+name+'"]');
                    }
                }
            }
        }

    }
</script>
